module.exports = __webpack_public_path__ + "img/card-back3.37697846.svg";